import type { InitiativeRole } from '@/api/Initiative/types.ts'
import type { FetchParams } from '@/api/types.ts'

export interface CurrentUser {
  id: number
  sub: string
  name: string
  email: string
  superAdmin: {
    user: PermissionAdminLevel
    initiative: PermissionAdminLevel
    business: PermissionAdminLevel
  }
  permissions: unknown[]
  initiatives: Record<number, InitiativePermission>
}

interface InitiativePermission {
  level: PermissionLevel.ADMIN | PermissionLevel.NONE
  initiativeRole?: InitiativeRole
  features?: Record<number, FeaturePermission>
}

interface FeaturePermission {
  web?: LayoutPermission
  mobile?: LayoutPermission
}

export interface LayoutPermission {
  level: PermissionLevel
  rules: unknown[]
}

export interface UserFetchParams extends FetchParams {
  enable?: boolean
}

export interface UserData {
  id: string
  name: string
  email: string
  enabled: boolean
  createdAt: string
}

export interface UserFormData {
  name: string
  email: string
  enabled: boolean
  password: string
  superAdmin: boolean
  superAdminUser: PermissionAdminLevel
  superAdminInitiative: PermissionAdminLevel
  superAdminBusiness: PermissionAdminLevel
}

export interface AlterPasswordData {
  password: string
}

export enum PermissionAdminLevel {
  ADMIN = 'ADMIN',
  WRITE = 'WRITE',
  READ = 'READ',
  NONE = 'NONE',
}

export enum PermissionLevel {
  ADMIN = 'admin',
  WRITE = 'write',
  COLLECTOR = 'collector',
  READ = 'read',
  LOOKUP = 'lookup',
  NONE = 'none',
}
